export const PENDING_DISCHARGED_STATUS_ID = 'recAvB7BC9yhl7y7x';
export const DISCHARGED_STATUS_ID = 'recT6xOYXI2LmGDpo';
// Status de una NZ recién creada, antes de cargar sus horarios de trabajo. Reemplaza a
// pending discharged para este momento del ciclo de vida (cambio de backend/api-core).
export const NEW_STATUS_ID = 'recMEGbv5jTl6l2Av';
